import React, { useRef, forwardRef, useImperativeHandle } from 'react';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import Slider, { Settings } from 'react-slick';
import { SliderWrapper, StyledArrow } from './styles/AssessmentSlider.styles';
import {
  AssessmentSliderRef,
  CustonArrowProps,
} from './types/AssessmentSlider.types';

function CustomArrow(props: CustonArrowProps) {
  const { onClick, className = '', currentSlide } = props;
  const isNext = className.includes('slick-next');
  const isPrev = className.includes('slick-prev');
  return (
    <StyledArrow className={className} onClick={onClick}>
      {isNext && <span className="label-next">Next Question</span>}
      {isPrev && (
        <span className="label-prev">
          {currentSlide === 0 ? 'Back' : 'Previous Question'}
        </span>
      )}
    </StyledArrow>
  );
}

const defaultProps = {
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  draggable: false,
  adaptiveHeight: false,
  infinite: false,
  nextArrow: <CustomArrow />,
  prevArrow: <CustomArrow />,
};

export const AssessmentSlider = forwardRef<
  AssessmentSliderRef | null,
  Settings
>((props, ref): JSX.Element => {
  const sliderRef = useRef<Slider | null>(null);

  const nextSlide = () => {
    sliderRef.current?.slickNext();
  };

  const prevSlide = () => {
    sliderRef.current?.slickPrev();
  };

  useImperativeHandle(ref, () => ({ nextSlide, prevSlide }));

  return (
    <SliderWrapper>
      <Slider ref={sliderRef} {...defaultProps} {...props}>
        {props.children}
      </Slider>
    </SliderWrapper>
  );
});
